import React from 'react';
import { Section } from './Section';
import { Droplets } from 'lucide-react';
export function MechanismSection() {
  return <Section className="bg-forest text-cream" data-id="element-82">
      <div className="text-center mb-10" data-id="element-83">
        <Droplets className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-84" />
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-85">
          La solución no es una dieta, es el Mecanismo SSS
        </h2>
        <h3 className="text-xl text-gold-light font-medium" data-id="element-86">
          (Sodio-Sustitución-Saciedad)
        </h3>
      </div>
      <div className="bg-forest-light rounded-2xl p-8 md:p-10 border border-forest" data-id="element-87">
        <p className="text-lg leading-relaxed text-cream-dark" data-id="element-88">
          Este protocolo de 72 horas no busca que pierdas peso milagrosamente;
          busca que "vacíes" el tanque de inflamación. Al sustituir minerales
          específicos y activar tu sistema linfático de forma manual, le das
          permiso a tu cuerpo para soltar el líquido retenido y calmar tu
          sistema digestivo de forma inmediata.
        </p>
      </div>
    </Section>;
}